var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"balance"},[_c('h3',{staticClass:"balance__text"},[_vm._v(_vm._s(_vm.$t('payments.balance'))+":")]),_c('h2',{staticClass:"balance__amount"},[_vm._v(_vm._s(_vm._f("currency")(_vm.balance)))])])}
var staticRenderFns = []

export { render, staticRenderFns }